module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roy R. Manstan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("ROY R. MANSTAN is the co-author of "), _c('I', [_vm._v("Turtle: David Bushnell's Revolutionary Vessel ")]), _vm._v("and author of "), _c('I', [_vm._v("Cold Warriors: The Navy's Engineering and Diving Support Unit")]), _vm._v(". He lives in East Haddam, CT.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aRPeY8/tc-custom/9780819578372.jpg?1704717895187",
      "alt": "This image is the cover for the book Listeners"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Listeners\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An untold story of scientists and engineers who changed the course of World War I")])]), _c('p', [_vm._v(" Roy R. Manstan's new book documents the rise of German submarines in World War I and the Allies' successful response of tracking them with innovative listening devices—precursors to modern sonar. "), _c('i', [_vm._v("The Listeners: U-boat Hunters During the Great War ")]), _vm._v("details the struggle to find a solution to the unanticipated efficiency of the German U-boat as an undersea predator. Success or failure was in the hands and minds of the scientists and naval personnel at the Naval Experimental Station in New London, Connecticut. Through the use of archival materials, personal papers, and memoirs "), _c('i', [_vm._v("The Listeners")]), _vm._v(" takes readers into the world of the civilian scientists and engineers and naval personnel who were directly involved with the development and use of submarine detection technology during the war. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wesleyan University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0